import { useState, useCallback, useEffect } from 'react';
import gun from '../config/gun.config';

const STORAGE_KEY = 'stabeon_blocked';

export function useBlockList(myId: string | null) {
  const [blockedIds, setBlockedIds] = useState<Set<string>>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? new Set(JSON.parse(saved)) : new Set();
    } catch { return new Set(); }
  });

  // Persist to localStorage
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...blockedIds]));
  }, [blockedIds]);

  const blockUser = useCallback((userId: string) => {
    setBlockedIds(prev => new Set([...prev, userId]));
    // Also store in GUN for cross-device sync
    if (myId) {
      gun.get('stabeon_blocks').get(myId).get(userId).put(true);
    }
  }, [myId]);

  const unblockUser = useCallback((userId: string) => {
    setBlockedIds(prev => {
      const next = new Set(prev);
      next.delete(userId);
      return next;
    });
    if (myId) {
      gun.get('stabeon_blocks').get(myId).get(userId).put(null);
    }
  }, [myId]);

  const isBlocked = useCallback((userId: string): boolean => {
    return blockedIds.has(userId);
  }, [blockedIds]);

  const reportUser = useCallback((userId: string, reason: string) => {
    gun.get('stabeon_reports').set({
      reporterId: myId,
      reportedId: userId,
      reason,
      timestamp: Date.now(),
    } as any);
  }, [myId]);

  return { blockedIds, blockUser, unblockUser, isBlocked, reportUser };
}
